/**
 * Route guard. Two modes:
 *   <RoleGuard allow={['admin','supervisor']}>...    (legacy role-based)
 *   <RoleGuard modules={['admin_agents']}>...        (Phase 7 module-based, ANY match)
 *
 * Both can be combined; module mode wins when both are present.
 */
import React from 'react';
import { Navigate } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import { useAuth } from '../auth/AuthProvider';
import { permissionsApi } from '../api/client';

export default function RoleGuard({ allow, modules, fallback = '/softphone', children }) {
  const { role } = useAuth();
  const { data: perms, isLoading } = useQuery({
    queryKey: ['permissions', 'me'],
    queryFn: () => permissionsApi.me(),
    staleTime: 60_000,
    enabled: !!modules,
  });

  if (modules) {
    if (isLoading) return null;
    const isAdmin = perms?.is_admin;
    if (isAdmin) return children;
    const allowed = new Set(perms?.modules || []);
    const ok = modules.some((m) => allowed.has(m));
    if (!ok) return <Navigate to={fallback} replace />;
    return children;
  }

  if (allow && !allow.includes(role)) {
    return <Navigate to={fallback} replace />;
  }
  return children;
}
